import { motion } from "framer-motion";
import logoGrayMark from "../../static/logo-gray-mark.png";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <motion.div
      className="w-full h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <section className="w-full h-full px-6 py-16 text-center bg-white md:px-10 lg:px-16 lg:py-24">
        <div className="relative w-full h-full max-w-4xl py-12 mx-auto border wrapper border-as-green-100 md:py-16">
          <div className="absolute left-1/2 top-0 flex h-[4.5rem] w-20 -translate-x-1/2 -translate-y-1/2 items-center justify-center bg-white">
            <img
              className="block h-[2.1875rem] w-[2.4375rem]"
              src={logoGrayMark}
              alt=""
            />
          </div>
          <div className="w-full max-w-2xl mx-auto">
            <p className="text-lg font-bold text-as-green-100">404</p>
            <h1 className="mb-4 mt-3 text-3xl !leading-tight md:mb-6 md:mt-5 md:text-5xl">
              Page not found
            </h1>
            <p className="max-w-full mx-auto w-80">
              Sorry, we couldn’t find the page you’re looking for.
            </p>
          </div>
          <div className="flex justify-center gap-3 mt-6 md:mt-10 md:gap-5">
            <button
              className="btn btn--primary"
              onClick={() => {
                navigate(-1);
              }}
            >
              Go back
            </button>
            <a href="/contact" className="btn btn--secondary">
              Contact us
            </a>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default PageNotFound;
